import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from '@dch/ng-common';
import { IOverlayerOptions } from '@dch/pxs-angular-design-system/src/lib/overlayer';
import { OVERVIEW_PAGE } from '../../config/my-bill.constants';
import { MyScarletService } from '../../services/my-scarlet.service';

@Component({
  selector: 'my-bill-modal-login-required',
  templateUrl: './my-bill-modal-login-required.component.html',
  standalone: false,
})
export class MyBillModalLoginRequiredComponent {
  @Input() showModal: boolean;
  @Input() redirectToLoginLink: string;
  @Output() hideModal = new EventEmitter<boolean>();
  options: IOverlayerOptions = {
    displayCloseIcon: true,
    backDrop: true,
    closeViaBackdrop: true,
    focusOnBox: true,
  };

  constructor(
    private router: Router,
    private environmentService: EnvironmentService,
    private scarletService: MyScarletService
  ) {}

  onClickOnLogin() {
    if (this.environmentService.isSmoothAccess) {
      window.location.assign(
        window.location.href
          .replace(
            '/smoothAccess',
            this.scarletService.isScarlet() ? '/myscarlet' : '/myproximus'
          )
          .replace(this.router.url, OVERVIEW_PAGE)
      );
    } else {
      window.location.assign(
        window.location.href.replace(this.router.url, this.redirectToLoginLink)
      );
    }
  }

  closeModal() {
    this.hideModal.emit(true);
  }
}
